import React, { useState } from "react";
import { Container, Form, Button, Card } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { AuthService } from "../services/AuthService";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../assets/logo.png";

function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();

        try {

            const data = await AuthService.login(email, password);

            if (!data.success) {
                alert("Invalid login");
                return;
            }

            // store token
            localStorage.setItem("adminToken", data.token);
            localStorage.setItem("adminUser", JSON.stringify(data.user));

            navigate("/dashboard");

        } catch (err) {
            alert("Invalid email or password");
        }
    };

    return (
        <Container className="d-flex justify-content-center align-items-center vh-100">

            <Card className="login-card" style={{ width: "400px", padding: "25px" }}>

                <div className="text-center mb-3">
                    <img
                        src={logo}
                        alt="LeoFair"
                        style={{
                            width: "180px",
                            marginBottom: "10px"
                        }}
                    />
                </div>

                <h4 className="text-center mb-4">Admin Login</h4>

                <Form onSubmit={handleLogin}>

                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Password</Form.Label>

                        <div style={{ position: "relative" }}>

                            <Form.Control
                                type={showPassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={{ paddingRight: "40px" }}
                            />

                            <span
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: "absolute",
                                    right: "12px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#666"
                                }}
                            >
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                            </span>

                        </div>

                    </Form.Group>

                    <Button type="submit" className="w-100">
                        Login
                    </Button>

                </Form>

                <div className="text-center mt-3">
                    <Link to="/forgot-password">Forgot Password?</Link>
                </div>

            </Card>

        </Container>
    );
}

export default Login;